var map = {
	"./ca.png": "aaae",
	"./courses.png": "00cd",
	"./createcourse.png": "a5fc",
	"./customer-service.png": "75bb",
	"./error.png": "1fe8",
	"./fingers/1.png": "6d61",
	"./fingers/2.png": "b575",
	"./fingers/3.png": "bf4f",
	"./fingers/4.png": "1c77",
	"./fingers/5.png": "c9d9",
	"./hourglass.png": "3c9c",
	"./images/48icon.png": "eecb",
	"./logo.svg": "9b19",
	"./logoblack.svg": "6ea9",
	"./logopng/44/2.png": "6bf4",
	"./logopng/44/4.png": "83dd",
	"./logopng/44/8.png": "1b3a",
	"./logopng/44/9.png": "32bc",
	"./logopng/512/2.png": "65d3",
	"./logopng/512/4.png": "db05",
	"./logopng/512/8.png": "8929",
	"./logopng/512/9.png": "09a7",
	"./logopng/small.png": "b608",
	"./logopng/small44.png": "c010",
	"./logosmall.svg": "0591",
	"./logosvg/2.svg": "ffbf",
	"./logosvg/4.svg": "2d5f",
	"./logosvg/8.svg": "0c55",
	"./logosvg/9.svg": "bb94",
	"./product.png": "8cc9",
	"./questions.png": "0340",
	"./questionsend.png": "34f5",
	"./settings.png": "3e4e",
	"./signboard.png": "3f2a",
	"./success.png": "6582",
	"./video-player.png": "4fc5",
	"./yoga.png": "7282d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";